import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-mode"
export default class extends Controller {
	initialize() {
		this.storedTheme = localStorage.getItem('theme')
	}

	connect() {
		window.addEventListener('DOMContentLoaded', this.modeToggle())
	}

	getPreferredTheme() {
		if (this.storedTheme) {
			return this.storedTheme
		}
		return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'light'
	}

	setTheme(theme) {
		if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			document.documentElement.setAttribute('data-bs-theme', 'dark')
		} else {
			document.documentElement.setAttribute('data-bs-theme', theme)
			if (theme === 'dark') {
				const lightItems = document.querySelectorAll('.light-mode-item')
				const darkItems = document.querySelectorAll('.dark-mode-item')
				lightItems.forEach(item => {
					item.style.setProperty('display', 'none', 'important');
				});
				darkItems.forEach(item => {
					item.style.setProperty('display', 'inline-block', 'important');
				});
			} else {
				const darkItems = document.querySelectorAll('.dark-mode-item')
				const lightItems = document.querySelectorAll('.light-mode-item')
				darkItems.forEach(item => {
					item.style.setProperty('display', 'none', 'important');
				});
				lightItems.forEach(item => {
					item.style.setProperty('display', 'inline-block', 'important');
				});
			}
		}
	}

	clicked() {
		this.modeToggle()
	}

	modeToggle() {
		var el = document.querySelector('.theme-icon-active');
		if (el != 'undefined' && el != null) {
			const showActiveTheme = theme => {
				const activeThemeIcon = document.querySelector('.theme-icon-active use')
				const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
				const svgOfActiveBtn = btnToActive.querySelector('.mode-switch use').getAttribute('href')

				document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
					element.classList.remove('active')
				})

				btnToActive.classList.add('active')
				activeThemeIcon.setAttribute('href', svgOfActiveBtn)
			}

			window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
				if (storedTheme !== 'light' || storedTheme !== 'dark') {
					this.setTheme(this.getPreferredTheme())
				}
			})

			showActiveTheme(this.getPreferredTheme())

			document.querySelectorAll('[data-bs-theme-value]')
				.forEach(toggle => {
					toggle.addEventListener('click', () => {
						const theme = toggle.getAttribute('data-bs-theme-value')
						localStorage.setItem('theme', theme)
						this.setTheme(theme)
						showActiveTheme(theme)
					})
				})
		}
	}
}